import { HelpCircle, } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function HelpButton() {

    return (
        <>
            <Link
                to={"/company/dashboard-documentation"}
                className={`
                    w-10 h-10 rounded-lg flex items-center justify-center
                    transition-all duration-300 group relative
                `}
            >
                <HelpCircle className={`
                    w-5 h-5 transition-all duration-300
                    
                `} />
            </Link>
        </>
    );
}